import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { SwitchField } from '@/modules/common/components/molecules/inputs/switch-field';

import { FORM_FIELD_CONSIDER_MEMBER_CAPACITY } from '../../../../constants/time-off-type-form-fields';
import { TimeOffTypeSetupFormData } from '../../../../validations/time-off-type-validation';

interface MemberCapacitySectionProps {
  form: UseFormReturn<TimeOffTypeSetupFormData>;
  isReadMode: boolean;
}

export function MemberCapacitySection({ form, isReadMode }: MemberCapacitySectionProps) {
  const { t } = useTranslation('authenticated.settings');

  return (
    <Card>
      <CardContent className="space-y-4 p-6">
        <div>
          <h3 className="text-md font-semibold">
            {t('pages.timeOff.details.sections.capacity.title')}
          </h3>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {t('pages.timeOff.details.sections.capacity.description')}
          </p>
        </div>

        <SwitchField
          name={FORM_FIELD_CONSIDER_MEMBER_CAPACITY}
          control={form.control}
          label={t('pages.timeOff.details.sections.capacity.toggle')}
          disabled={isReadMode}
        />
      </CardContent>
    </Card>
  );
}
